import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
   color: #1a1a1a;

   .select {
      h4 { 
         white-space: nowrap;
         width: 130px; 
         font-weight: 500;
      }
   }

   /* Mode selector styling */
   > div:first-child {
      margin-bottom: 20px;
      
      /* Make label not wrap */
      label, span {
         white-space: nowrap;
      }
   }

   /* Config Card Wrapper for Settings */
   .config-card {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 15px;
      margin-bottom: 20px;
   }

   /* Cache & Scroll Settings */
   .settings-row {
      display: flex;
      align-items: center;
      gap: 12px;
   }

   .cache-toggle {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      padding: 8px 12px;
      background-color: #f8fafc;
      border-radius: 8px;
      
      .cache-label {
         font-size: 13px;
         font-weight: 500;
         color: #4a5568;
      }
      
      .toggle-switch {
         width: 40px;
         height: 22px;
         background-color: #e2e8f0;
         border-radius: 11px;
         cursor: pointer;
         position: relative;
         transition: background-color 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
         box-shadow: inset 0 1px 2px rgba(0,0,0,0.05);
         
         &.active {
            background-color: #10b981; /* Premium Green */
         }
         
         .toggle-slider {
            position: absolute;
            top: 2px;
            left: 2px;
            width: 18px;
            height: 18px;
            background-color: white;
            border-radius: 50%;
            transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
            box-shadow: 0 2px 4px rgba(0,0,0,0.15);
         }
         
         &.active .toggle-slider {
            transform: translateX(18px);
         }
      }
   }

   .scroll-count {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 8px 12px;
      background-color: #f8fafc;
      border-radius: 8px;

      span {
         font-size: 12px;
         font-weight: 600;
         color: #4a5568;
      }

      input {
         width: 100%;
         height: 28px;
         border: 1px solid #cbd5e1;
         border-radius: 6px;
         padding: 0 10px;
         font-size: 14px;
         color: #1a202c;
         background-color: #ffffff;
         outline: none;
         transition: all 0.2s ease;

         &:focus {
            border-color: #3b82f6;
            background-color: #ffffff;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
         }
      }
   }
   
   .add-container {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 20px;

      .add {
         flex: 1;
         position: relative;

         input {
            width: 100%;
            height: 44px;
            border: 1px solid #93c5fd;
            background-color: #ffffff;
            border-radius: 22px;
            font-size: 14px;
            padding: 0 20px;
            color: #2d3748;
            transition: all 0.2s ease;

            &::placeholder {
               color: #a0aec0;
               font-weight: 400;
            }

            &:focus {
               outline: none;
               border-color: #3b82f6;
               box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
            }
         }
      }

      .add-action-btn {
         height: 44px;
         padding: 0 20px;
         background-color: #3b82f6;
         color: white;
         border: none;
         border-radius: 22px;
         font-size: 14px;
         font-weight: 500;
         cursor: pointer;
         transition: background-color 0.2s ease;
         white-space: nowrap;

         &:hover {
            background-color: #2563eb;
         }
      }
   }
   
   /* URL Library Section */
   .library-section {
      margin-bottom: 20px;
      position: relative;
      
      .library-button {
         display: flex;
         align-items: center;
         justify-content: center;
         gap: 8px;
         padding: 10px 16px;
         background-color: transparent;
         border: 1px dashed #cbd5e1;
         border-radius: 8px;
         cursor: pointer;
         font-size: 13px;
         font-weight: 500;
         color: #64748b;
         transition: all 0.2s ease;
         
         &:hover {
            background-color: #f8fafc;
            border-color: #94a3b8;
         }
         
         svg {
            font-size: 12px;
         }
      }
      
      .library-dropdown {
         position: absolute;
         top: 100%;
         left: 0;
         right: 0;
         background: rgba(255, 255, 255, 0.95);
         backdrop-filter: blur(10px);
         border: 1px solid rgba(0,0,0,0.08);
         border-radius: 10px;
         box-shadow: 0 10px 25px rgba(0,0,0,0.1);
         z-index: 100;
         max-height: 220px;
         overflow-y: auto;
         margin-top: 8px;
         padding: 6px;
         
         /* Scrollbar styling */
         &::-webkit-scrollbar {
            width: 6px;
         }
         &::-webkit-scrollbar-thumb {
            background-color: #cbd5e1;
            border-radius: 3px;
         }
      }
      
      .library-item {
         display: flex;
         align-items: center;
         justify-content: space-between;
         padding: 10px 12px;
         cursor: pointer;
         border-radius: 6px;
         transition: all 0.2s ease;
         margin-bottom: 2px;
         
         &:hover {
            background-color: #f1f5f9;
            transform: translateX(2px);
         }
         
         &:last-child {
            margin-bottom: 0;
         }
         
         .library-url {
            font-size: 13px;
            color: #334155;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 220px;
            font-weight: 500;
         }
         
         .library-mode {
            font-size: 10px;
            font-weight: 700;
            padding: 3px 8px;
            border-radius: 12px;
            color: white;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            
            &.normal {
               background-color: #3b82f6;
               box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
            }
            
            &.vlm {
               background-color: #8b5cf6;
               box-shadow: 0 2px 4px rgba(139, 92, 246, 0.3);
            }
         }
      }
      
      .library-empty {
         padding: 20px;
         text-align: center;
         font-size: 13px;
         color: #94a3b8;
         font-style: italic;
      }
   }
   
   .items {
      margin-top: 15px;
      
      .title {
         display: flex;
         align-items: center;
         margin-bottom: 12px;
         
         h4 { 
            font-weight: 600; 
            font-size: 14px;
            color: #1e293b;
            margin: 0;
         }
         span { 
            color: #94a3b8; 
            margin-left: 8px; 
            font-size: 13px;
         }
      }
      ul {
         margin: 0;
         padding: 0;
         list-style: none;
         overflow: auto;
         max-height: 180px;
         
         /* Scrollbar styling */
         &::-webkit-scrollbar {
            width: 4px;
         }
         &::-webkit-scrollbar-thumb {
            background-color: #e2e8f0;
            border-radius: 2px;
         }

         li {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #ffffff;
            border: 1px solid #e2e8f0;
            padding: 0 16px;
            font-size: 13px;
            border-radius: 8px;
            height: 44px;
            transition: all 0.2s ease;
            overflow: hidden;

            &:not(:last-of-type) {
               margin-bottom: 8px;
            }
            
            &:hover {
               border-color: #cbd5e1;
            }

            .url-content {
               display: flex;
               align-items: center;
               gap: 10px;
               opacity: 0.85;
               white-space: nowrap;
               overflow: hidden;
               text-overflow: ellipsis;
               max-width: 250px;
               
               .url-icon {
                  color: #94a3b8;
                  font-size: 12px;
                  flex-shrink: 0;
               }
            }
            
            .remove {
               position: absolute;
               top: 0;
               right: 0;
               display: flex;
               align-items: center;
               justify-content: center;
               width: 44px;
               height: 100%;
               color: #ef4444;
               background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 25%, rgba(255,255,255,1) 100%);
               cursor: pointer;
               font-size: 16px;
               opacity: 0;
               transform: translateX(10px);
               transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

               &:hover {
                  color: #b91c1c;
                  background: #fee2e2;
               }
            }
            
            &:hover .remove {
               opacity: 1;
               transform: translateX(0);
            }
         }
      }
   }
`;